<template>
  <div>
    <v-app-bar flat color="red-darken-3">
      <v-row>
        <v-app-bar-title class="pl-5">{{
          $t("settings.label")
        }}</v-app-bar-title>
        <v-divider class="mx-5 hidden-md-and-down" inset vertical />
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {},
};
</script>
<style>
.v-app-bar-title__content {
  flex: 1 1 auto !important;
  min-width: 0;
}
</style>
